export enum NotificationField {
  Id = 'id',
  Subject = 'subject',
  Classification = 'classification',
  ProcessingStatus = 'processing_status',
  JobId = 'job_id',
  Timestamp = 'timestamp',
}
